import { CategoryItem, StatItem } from '../types';

export const CATEGORIES_DATA: CategoryItem[] = [
  {
    id: 'pdf-tools',
    title: 'PDF Tools',
    countText: '40 Tools',
    description: 'Merge, split, compress, convert PDF files and more',
    iconName: 'FileText',
    colorTheme: 'red',
    iconBgClass: 'from-red-500 to-rose-600 text-white shadow-red-500/25',
    bgGlowClass: 'shadow-red-500/25',
    gradientFrom: 'from-red-500',
    gradientTo: 'to-rose-600',
    borderColorDark: 'hover:border-red-500/50',
    borderColorLight: 'hover:border-red-300',
    iconColorDark: 'text-red-400',
    iconColorLight: 'text-red-600',
    tools: [
      { id: 'pdf-merger', name: 'Merge PDF', description: 'Combine multiple PDFs into a single file', isPopular: true },
      { id: 'pdf-splitter', name: 'Split PDF', description: 'Split PDF into files' },
      { id: 'pdf-extractor', name: 'Extract PDF', description: 'Extract specific pages from a PDF' },
      { id: 'pdf-compressor', name: 'Compress PDF', description: 'Reduce PDF file size without quality loss', isPopular: true },
      { id: 'images-to-pdf', name: 'Images to PDF', description: 'Bundle multiple images into a formatted PDF', isPopular: true },
      { id: 'pdf-to-images', name: 'PDF to Images', description: 'Convert PDF pages into high-resolution images' },
      { id: 'pdf-grayscale-converter', name: 'PDF Grayscale Converter', description: 'Convert color PDF to black & white grayscale' }
    ]
  },
  {
    id: 'image-tools',
    title: 'Image Tools',
    countText: '61 Tools',
    description: 'Edit, convert, compress images and apply effects',
    iconName: 'Image',
    colorTheme: 'green',
    iconBgClass: 'from-emerald-500 to-green-600 text-white shadow-emerald-500/25',
    bgGlowClass: 'shadow-emerald-500/25',
    gradientFrom: 'from-emerald-500',
    gradientTo: 'to-green-600',
    borderColorDark: 'hover:border-emerald-500/50',
    borderColorLight: 'hover:border-emerald-300',
    iconColorDark: 'text-emerald-400',
    iconColorLight: 'text-emerald-600',
    tools: [
      { id: 'image-compressor', name: 'Compress Image', description: 'Optimize JPG, PNG, WebP images instantly', isPopular: true },
      { id: 'image-resizer', name: 'Resize Image', description: 'Change width and height dimensions of images' },
      { id: 'crop-image', name: 'Crop Image', description: 'Crop images to standard aspect ratios or freehand' },
      { id: 'images-to-pdf', name: 'Images to PDF', description: 'Bundle multiple images into a formatted PDF', isPopular: true },
      { id: 'pdf-to-images', name: 'PDF to Images', description: 'Convert PDF pages into high-resolution images' }
    ]
  },
  {
    id: 'text-tools',
    title: 'Text Tools',
    countText: '50 Tools',
    description: 'Count, convert, format and manipulate text',
    iconName: 'Type',
    colorTheme: 'purple',
    iconBgClass: 'from-purple-500 to-indigo-600 text-white shadow-purple-500/25',
    bgGlowClass: 'shadow-purple-500/25',
    gradientFrom: 'from-purple-500',
    gradientTo: 'to-indigo-600',
    borderColorDark: 'hover:border-purple-500/50',
    borderColorLight: 'hover:border-purple-300',
    iconColorDark: 'text-purple-400',
    iconColorLight: 'text-purple-600',
    tools: [
      { id: 'word-counter', name: 'Word & Character Counter', description: 'Analyze text length, reading time, and keyword density', isPopular: true, actionType: 'wordcount' },
      { id: 'case-converter', name: 'Case Converter', description: 'UPPERCASE, lowercase, Title Case, camelCase, snake_case' },
      { id: 'lorem-ipsum', name: 'Lorem Ipsum Generator', description: 'Generate placeholder text by paragraphs or sentences' }
    ]
  },
  {
    id: 'developer-tools',
    title: 'Developer Tools',
    countText: '67 Tools',
    description: 'Format, validate, convert and generate code',
    iconName: 'Code2',
    colorTheme: 'blue',
    iconBgClass: 'from-blue-500 to-cyan-600 text-white shadow-blue-500/25',
    bgGlowClass: 'shadow-blue-500/25',
    gradientFrom: 'from-blue-500',
    gradientTo: 'to-cyan-600',
    borderColorDark: 'hover:border-blue-500/50',
    borderColorLight: 'hover:border-blue-300',
    iconColorDark: 'text-blue-400',
    iconColorLight: 'text-blue-600',
    tools: [
      { id: 'json-formatter', name: 'JSON Formatter & Validator', description: 'Prettify, minify, and validate JSON data structures', isPopular: true, actionType: 'json' },
      { id: 'base64-encoder', name: 'Base64 Encoder & Decoder', description: 'Encode or decode strings and binary data in Base64' },
      { id: 'jwt-decoder', name: 'JWT Decoder', description: 'Decode JSON Web Token headers, payloads, and signatures' }
    ]
  },
  {
    id: 'color-tools',
    title: 'Color Tools',
    countText: '26 Tools',
    description: 'Pick, convert, generate and explore colors',
    iconName: 'Palette',
    colorTheme: 'amber',
    iconBgClass: 'from-amber-500 to-orange-600 text-white shadow-amber-500/25',
    bgGlowClass: 'shadow-amber-500/25',
    gradientFrom: 'from-amber-500',
    gradientTo: 'to-orange-600',
    borderColorDark: 'hover:border-amber-500/50',
    borderColorLight: 'hover:border-amber-300',
    iconColorDark: 'text-amber-400',
    iconColorLight: 'text-amber-600',
    tools: [
      { id: 'color-picker', name: 'Color Picker & Converter', description: 'Inspect, convert HEX, RGB, HSL, and CMYK colors', isPopular: true, actionType: 'color' },
      { id: 'palette-generator', name: 'Color Palette Generator', description: 'Generate cohesive color palettes with harmonic rules' }
    ]
  },
  {
    id: 'security-tools',
    title: 'Security Tools',
    countText: '20 Tools',
    description: 'Generate passwords, hashes and secure your data',
    iconName: 'ShieldCheck',
    colorTheme: 'teal',
    iconBgClass: 'from-teal-400 to-emerald-600 text-white shadow-teal-500/25',
    bgGlowClass: 'shadow-teal-500/25',
    gradientFrom: 'from-teal-400',
    gradientTo: 'to-emerald-600',
    borderColorDark: 'hover:border-teal-500/50',
    borderColorLight: 'hover:border-teal-300',
    iconColorDark: 'text-teal-400',
    iconColorLight: 'text-teal-600',
    tools: [
      { id: 'password-generator', name: 'Strong Password Generator', description: 'Generate ultra-secure, cryptographically random passwords', isPopular: true, actionType: 'password' },
      { id: 'hash-generator', name: 'Hash Generator (SHA-256 / MD5)', description: 'Generate cryptographic hashes for text and strings' }
    ]
  },
  {
    id: 'social-tools',
    title: 'Social Media Tools',
    countText: '25 Tools',
    description: 'Optimize content for all social media platforms',
    iconName: 'Share2',
    colorTheme: 'pink',
    iconBgClass: 'from-pink-500 to-rose-600 text-white shadow-pink-500/25',
    bgGlowClass: 'shadow-pink-500/25',
    gradientFrom: 'from-pink-500',
    gradientTo: 'to-rose-600',
    borderColorDark: 'hover:border-pink-500/50',
    borderColorLight: 'hover:border-pink-300',
    iconColorDark: 'text-pink-400',
    iconColorLight: 'text-pink-600',
    tools: [
      { id: 'hashtag-generator', name: 'Hashtag Generator', description: 'Discover trending tags for Instagram, X, TikTok, and LinkedIn' },
      { id: 'social-resizer', name: 'Social Image Resizer', description: 'Resize graphics for stories, posts, headers, and banners' }
    ]
  },
  {
    id: 'calculators',
    title: 'Calculators',
    countText: '52 Tools',
    description: 'Calculate anything with our smart calculators',
    iconName: 'Calculator',
    colorTheme: 'yellow',
    iconBgClass: 'from-amber-400 to-yellow-600 text-white shadow-amber-400/25',
    bgGlowClass: 'shadow-amber-400/25',
    gradientFrom: 'from-amber-400',
    gradientTo: 'to-yellow-600',
    borderColorDark: 'hover:border-amber-400/50',
    borderColorLight: 'hover:border-amber-300',
    iconColorDark: 'text-amber-400',
    iconColorLight: 'text-amber-600',
    tools: [
      { id: 'percentage-calc', name: 'Percentage Calculator', description: 'Calculate percent increases, discounts, and fractions' },
      { id: 'loan-calc', name: 'Loan & Mortgage Calculator', description: 'Estimate monthly payment, total interest, and schedules' }
    ]
  },
  {
    id: 'file-tools',
    title: 'File Tools',
    countText: '30 Tools',
    description: 'Analyze, convert and manage your files',
    iconName: 'Folder',
    colorTheme: 'blue',
    iconBgClass: 'from-sky-500 to-blue-600 text-white shadow-sky-500/25',
    bgGlowClass: 'shadow-sky-500/25',
    gradientFrom: 'from-sky-500',
    gradientTo: 'to-blue-600',
    borderColorDark: 'hover:border-sky-500/50',
    borderColorLight: 'hover:border-sky-300',
    iconColorDark: 'text-sky-400',
    iconColorLight: 'text-sky-600',
    tools: [
      { id: 'zip-extractor', name: 'ZIP Archiver & Extractor', description: 'Compress files into ZIP archives or extract files locally' },
      { id: 'csv-to-json', name: 'CSV to JSON Converter', description: 'Convert tabular CSV spreadsheets into structured JSON' }
    ]
  },
  {
    id: 'data-tools',
    title: 'Data Tools',
    countText: '35 Tools',
    description: 'View, format, analyze and manipulate data',
    iconName: 'Database',
    colorTheme: 'purple',
    iconBgClass: 'from-violet-500 to-purple-600 text-white shadow-purple-500/25',
    bgGlowClass: 'shadow-purple-500/25',
    gradientFrom: 'from-violet-500',
    gradientTo: 'to-purple-600',
    borderColorDark: 'hover:border-purple-500/50',
    borderColorLight: 'hover:border-purple-300',
    iconColorDark: 'text-purple-400',
    iconColorLight: 'text-purple-600',
    tools: [
      { id: 'json-to-xml', name: 'JSON to XML Converter', description: 'Convert JSON structures into clean XML documents' }
    ]
  },
  {
    id: 'productivity-tools',
    title: 'Productivity Tools',
    countText: '30 Tools',
    description: 'Boost your productivity with useful tools',
    iconName: 'Zap',
    colorTheme: 'green',
    iconBgClass: 'from-lime-500 to-emerald-600 text-white shadow-lime-500/25',
    bgGlowClass: 'shadow-lime-500/25',
    gradientFrom: 'from-lime-500',
    gradientTo: 'to-emerald-600',
    borderColorDark: 'hover:border-lime-500/50',
    borderColorLight: 'hover:border-lime-300',
    iconColorDark: 'text-lime-400',
    iconColorLight: 'text-lime-600',
    tools: [
      { id: 'pomodoro-timer', name: 'Pomodoro Timer', description: 'Boost focus with customizable work and rest cycles' }
    ]
  },
  {
    id: 'unit-conversion',
    title: 'Unit Conversion',
    countText: '40 Tools',
    description: 'Convert between units of measurement',
    iconName: 'Ruler',
    colorTheme: 'teal',
    iconBgClass: 'from-teal-400 to-cyan-600 text-white shadow-teal-500/25',
    bgGlowClass: 'shadow-teal-500/25',
    gradientFrom: 'from-teal-400',
    gradientTo: 'to-cyan-600',
    borderColorDark: 'hover:border-teal-500/50',
    borderColorLight: 'hover:border-teal-300',
    iconColorDark: 'text-teal-400',
    iconColorLight: 'text-teal-600',
    tools: [
      { id: 'length-converter', name: 'Length Converter', description: 'Meters, feet, inches, miles, and kilometers' }
    ]
  },
  {
    id: 'time-date-tools',
    title: 'Time & Date Tools',
    countText: '25 Tools',
    description: 'Calculate time, dates and durations',
    iconName: 'Clock',
    colorTheme: 'rose',
    iconBgClass: 'from-rose-500 to-pink-600 text-white shadow-rose-500/25',
    bgGlowClass: 'shadow-rose-500/25',
    gradientFrom: 'from-rose-500',
    gradientTo: 'to-pink-600',
    borderColorDark: 'hover:border-rose-500/50',
    borderColorLight: 'hover:border-rose-300',
    iconColorDark: 'text-rose-400',
    iconColorLight: 'text-rose-600',
    tools: [
      { id: 'time-zone-converter', name: 'World Time Zone Converter', description: 'Compare world time zones across cities' }
    ]
  },
  {
    id: 'financial-tools',
    title: 'Financial Tools',
    countText: '30 Tools',
    description: 'Calculate loans, EMI, interest and more',
    iconName: 'DollarSign',
    colorTheme: 'gold',
    iconBgClass: 'from-amber-400 to-yellow-600 text-white shadow-amber-400/25',
    bgGlowClass: 'shadow-amber-400/25',
    gradientFrom: 'from-amber-400',
    gradientTo: 'to-yellow-600',
    borderColorDark: 'hover:border-amber-400/50',
    borderColorLight: 'hover:border-amber-300',
    iconColorDark: 'text-amber-400',
    iconColorLight: 'text-amber-600',
    tools: [
      { id: 'loan-emi-calculator', name: 'Loan EMI Calculator', description: 'Calculate monthly loan EMI payments' }
    ]
  },
  {
    id: 'misc-tools',
    title: 'Miscellaneous',
    countText: '48 Tools',
    description: 'Random generators, utilities and fun tools',
    iconName: 'Grid',
    colorTheme: 'purple',
    iconBgClass: 'from-fuchsia-500 to-purple-600 text-white shadow-fuchsia-500/25',
    bgGlowClass: 'shadow-fuchsia-500/25',
    gradientFrom: 'from-fuchsia-500',
    gradientTo: 'to-purple-600',
    borderColorDark: 'hover:border-fuchsia-500/50',
    borderColorLight: 'hover:border-fuchsia-300',
    iconColorDark: 'text-fuchsia-400',
    iconColorLight: 'text-fuchsia-600',
    tools: [
      { id: 'qr-code-generator', name: 'QR Code Generator', description: 'Generate custom QR codes', isPopular: true, actionType: 'qr' }
    ]
  }
];

export const STATS_DATA: StatItem[] = [
  {
    id: 'tools-stat',
    value: '579+',
    label: 'Free Tools',
    iconName: 'Rocket',
    colorClass: 'bg-gradient-to-tr from-blue-500 to-indigo-600 text-white shadow-md shadow-blue-500/30'
  },
  {
    id: 'users-stat',
    value: '1M+',
    label: 'Happy Users',
    iconName: 'Users',
    colorClass: 'bg-gradient-to-tr from-purple-500 to-pink-600 text-white shadow-md shadow-purple-500/30'
  },
  {
    id: 'privacy-stat',
    value: '100%',
    label: 'Privacy First',
    iconName: 'ShieldCheck',
    colorClass: 'bg-gradient-to-tr from-emerald-500 to-teal-600 text-white shadow-md shadow-emerald-500/30'
  },
  {
    id: 'speed-stat',
    value: 'Instant',
    label: 'Results',
    iconName: 'Zap',
    colorClass: 'bg-gradient-to-tr from-amber-500 to-orange-500 text-white shadow-md shadow-amber-500/30'
  },
  {
    id: 'offline-stat',
    value: 'Works',
    label: 'Offline',
    iconName: 'Globe',
    colorClass: 'bg-gradient-to-tr from-cyan-500 to-blue-600 text-white shadow-md shadow-cyan-500/30'
  }
];
